import type { AppInfoResponse } from "src/queries/info/info.types";
import { useGlobalLocalContext } from "src/storage/localStorage";
import { queryClient } from "@utils/query-client.ts";
import type { UserTzContext } from "./TimeWindow.calendarPresets";

/** Readable from dfetch with no React — same tz + /api/info clock as TimeZoneSelector. */
export const getUserTzContextFromStores = (): UserTzContext => {
  const tz = useGlobalLocalContext.getState().tz;

  // The route loader prefetch and `useQueryAppInfo` write different keys under
  // the same prefix, so take whichever holds the newer clock.
  const [query] = queryClient
    .getQueryCache()
    .findAll({ queryKey: ["/api/info"] })
    .sort((a, b) => b.state.dataUpdatedAt - a.state.dataUpdatedAt);
  const data = query?.state.data as AppInfoResponse | undefined;

  return {
    serverTime: data?.time?.now,
    tz,
    fetchedAt: query?.state.dataUpdatedAt || Date.now(),
  };
};
